import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Routes, Route, Navigate } from "react-router-dom";

// Layouts
import AdminLayout from "./components/Layouts/AdminLayout";
import AdminProtectedRoute from "./Admin/components/AdminProtectedRoute";
import ProtectedRoute from "./components/ProtectedRoute";

// Auth Pages
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import AdminLogin from "./Admin/AdminLogin";
import AdminSignUp from "./Admin/AdminSignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminResetPassword from "./Admin/AdminResetPassword";
import AdminForgotPassword from "./Admin/AdminForgotPassword";

// Client Pages
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Notification from "./pages/Notification";
import CaseDetailsClients from "./pages/CaseDetailsClient";
import ClientTab from "./pages/tabs/ClientTab";

// Admin Pages
import DashBoard from "./Admin/DashBoard/DashBoard"; // We might retire this or keep it as "AnalyticsDashboard" wrapper
import AnalyticsDashboard from "./Admin/DashBoard/AnalyticsDashboard";
import AdminProfile from "./Admin/components/AdminProfile";
import DoToDo from "./Admin/dotodo/DoToDo";
import AppointmentList from "./Admin/Notification/AdminAppointments";
import FestivalInformer from "./Admin/FestivalInformer/FestivalInformer";
import MyLeads from "./Admin/Leads/MyLeads";
import HostChecker from "./Admin/HostChecker/HostChecker";
import NotificationManager from "./Admin/NotificationManager/NotifcationManager";
import AboutThis from "./Admin/AboutThis/AboutThis";
import MyClients from "./Admin/Clients/MyClients";
import MyProject from "./Admin/Projects/MyProject";
import MyHearings from "./Admin/Hearings/MyHearings";
import TimesheetPage from "./Admin/Timesheet/TimesheetPage";
import MyDocuments from "./Admin/Documents/MyDocuments";
import RequirementsList from "./Admin/Requirements/RequirementsList";
import ExcelGen from "./Admin/excelGen/ExcelGen";
import Generator from "./Admin/generator/Generator";
import Reader from "./Admin/Reader/Reader";
import ImageGen from "./Admin/ImageGen/ImageGen";
import InvoiceGenerator from "./Admin/invoiceGen/InvoiceGen";
import AiGenerators from "./Admin/AiGenerators/AiGenerators";
import LeadGen from "./Admin/LeadGen/LeadGen";
import WebsiteList from "./Admin/WebsiteList/WebsiteList";
import DocumentLists from "./Admin/DocumentLists/DocumentList";
import SocialMediaUploader from "./Admin/SocialMediaUploader/SocialMediaUploader";
import LockerData from "./Admin/LockerData/LockerData";
import NewsLetter from "./Admin/NewsLetter/NewsLetter";
import EmailMarketing from "./Admin/EmailMarketing/EmailMarketing";
import GMB from "./Admin/GMB/Gmb";
import ReviewsList from "./Admin/GmbReiview/GoogleReviewsDashboard";
import Agent from "./Admin/Agent/Agent";
import OneBot from "./Admin/Onebot/OneBot";
import AllInOne from "./Admin/Allinone/AllInOne";

// Edit/Detail Pages (keep them accessible)
import ProjectDetails from './Admin/Projects/ProjectDetails';
import EditProjectForm from "./Admin/Projects/EditProjectForm";
import ClientDetails from './Admin/Clients/ClientDetails';
import EditClient from './Admin/Clients/EditClient';
import EditHearingForm from "./Admin/Hearings/EditHearingForm";
import AddHearingForm from "./Admin/Hearings/AddHearingForm";
import EditTimesheet from "./Admin/Timesheet/EditTimesheet";
import AddTimesheetForm from "./Admin/Timesheet/AddTimesheetForm";
import DocumentPreview from "./Admin/Documents/DocumentPreview";
import Labels from "./Admin/Labels/Labels";
import StoredBusinessesPage from "./Admin/LeadGen/StoredBusinessesPage";


function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Routes>
        {/* --- Public Routes --- */}
        <Route path="/clientlogin" element={<Login />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />

        <Route path="/" element={<AdminLogin />} />
        <Route path="/AdminSignUp" element={<AdminSignUp />} />
        <Route path="/AdminResetPassword" element={<AdminResetPassword />} />
        <Route path="/AdminForgotPassword" element={<AdminForgotPassword />} />

        {/* --- Client Routes (Legacy Structure, could be improved later) --- */}
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/notifications" element={<Notification />} />
        <Route path="/clientcases/:id" element={<CaseDetailsClients />} />
        <Route path="/ClientTab" element={<ClientTab />} />

        {/* --- Admin Routes (Wrapped in Layout) --- */}
        <Route element={<AdminProtectedRoute><AdminLayout /></AdminProtectedRoute>}>
          <Route path="/DashBoard" element={<AnalyticsDashboard />} />
          <Route path="/admin-profile" element={<AdminProfile />} />
          <Route path="/dotodo" element={<DoToDo />} />
          <Route path="/appointments" element={<AppointmentList />} />
          <Route path="/festival-informer" element={<FestivalInformer />} />
          <Route path="/leads" element={<MyLeads />} />
          <Route path="/host-checker" element={<HostChecker />} />
          <Route path="/notifications" element={<NotificationManager />} />
          <Route path="/about" element={<AboutThis />} />

          <Route path="/myclients" element={<MyClients />} />
          <Route path="/Cases" element={<MyProject />} />
          <Route path="/hearings" element={<MyHearings />} />
          <Route path="/timesheets" element={<TimesheetPage />} />
          <Route path="/documents" element={<MyDocuments />} />
          <Route path="/requirements" element={<RequirementsList />} />

          <Route path="/excel-gen" element={<ExcelGen />} />
          <Route path="/blog-gen" element={<Generator />} />
          <Route path="/reader" element={<Reader />} />
          <Route path="/image-gen" element={<ImageGen />} />
          <Route path="/invoice-gen" element={<InvoiceGenerator />} />
          <Route path="/ai-generators" element={<AiGenerators />} />

          <Route path="/LeadGen" element={<LeadGen />} />
          {/* Note: Sidebar uses /lead-gen, but LeadGen might assume /LeadGen or I should just standardise. 
                I used /lead-gen in Sidebar. I'll use /lead-gen here. */}
          <Route path="/lead-gen" element={<LeadGen />} />
          <Route path="/website-list" element={<WebsiteList />} />
          <Route path="/document-lists" element={<DocumentLists />} />
          <Route path="/sm-uploader" element={<SocialMediaUploader />} />
          <Route path="/locker-data" element={<LockerData />} />
          <Route path="/newsletter" element={<NewsLetter />} />
          <Route path="/email-marketing" element={<EmailMarketing />} />

          <Route path="/gmb" element={<GMB />} />
          <Route path="/reviews" element={<ReviewsList />} />
          <Route path="/agent" element={<Agent />} />
          <Route path="/onebot" element={<OneBot />} />
          <Route path="/all-in-one" element={<AllInOne />} />

          {/* Sub-routes/Details that shouldn't appear in sidebar but need layout? 
                Actually, usually detail pages DO have sidebar. 
                So I put them here.
            */}
          <Route path="/cases/:id" element={<ProjectDetails />} />
          <Route path="/cases/edit/:id" element={<EditProjectForm />} />
          <Route path="/myclients/edit/:clientId" element={<EditClient />} />
          <Route path="/myclients/details/:clientId" element={<ClientDetails />} />
          <Route path="/hearings/edit/:id" element={<EditHearingForm />} />
          <Route path="/hearings/add" element={<AddHearingForm />} />
          <Route path="/timesheets/new" element={<AddTimesheetForm />} />
          <Route path="/timesheets/edit/:id" element={<EditTimesheet />} />
          <Route path="/preview/:id" element={<DocumentPreview />} />
          <Route path="/labels" element={<Labels />} />
          <Route path="/stored-businesses" element={<StoredBusinessesPage />} />
        </Route>

        {/* Redirects/Fallbacks */}
        <Route path="/clients" element={<Navigate to="/myclients" replace />} />
      </Routes>
    </>
  );
}

export default App;
